// Product Reviews Pagination
document.addEventListener("DOMContentLoaded", function () {
  function initProductReviews(sectionId) {
    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (!section) return;

    const reviewsList = section.querySelector("[data-reviews-list]");
    const pagination = section.querySelector("[data-reviews-pagination]");

    if (!reviewsList || !pagination) return;

    const reviewItems = Array.from(
      reviewsList.querySelectorAll("[data-review-index]")
    );
    const totalReviews = reviewItems.length;
    const reviewsPerPage = 5;
    const totalPages = Math.ceil(totalReviews / reviewsPerPage);

    if (totalReviews <= reviewsPerPage) {
      if (pagination) pagination.style.display = "none";
      return;
    }

    let currentPage = 1;

    const prevButton = pagination.querySelector("[data-pagination-prev]");
    const nextButton = pagination.querySelector("[data-pagination-next]");
    const numberButtons = Array.from(
      pagination.querySelectorAll(
        ".product-reviews-pagination-number[data-page]"
      )
    );

    function showPage(page) {
      if (page < 1 || page > totalPages) return;

      const startIndex = (page - 1) * reviewsPerPage;
      const endIndex = Math.min(startIndex + reviewsPerPage, totalReviews);

      // Get items to show and hide
      const itemsToShow = reviewItems.slice(startIndex, endIndex);
      const itemsToHide = reviewItems.filter(
        (item, index) => index < startIndex || index >= endIndex
      );

      // Hide items that shouldn't be visible
      if (typeof gsap !== "undefined") {
        // Get current height
        const currentHeight = reviewsList.offsetHeight;

        // Animate out - faster duration
        gsap.to(itemsToHide, {
          opacity: 0,
          y: -20,
          duration: 0.15,
          onComplete: function () {
            itemsToHide.forEach((item) => {
              item.setAttribute("data-hidden", "true");
              item.style.display = "none";
            });

            // Show new items temporarily to measure height (hidden with opacity)
            itemsToShow.forEach((item) => {
              item.setAttribute("data-hidden", "false");
              item.style.display = "block";
              gsap.set(item, { opacity: 0, y: 20 });
            });

            // Measure new height
            const newHeight = reviewsList.offsetHeight;

            // Set initial height for animation
            gsap.set(reviewsList, { height: currentHeight });

            // Animate container height and items in simultaneously
            gsap.to(reviewsList, {
              height: newHeight,
              duration: 0.4,
              ease: "power2.out",
            });

            gsap.to(itemsToShow, {
              opacity: 1,
              y: 0,
              duration: 0.4,
              stagger: 0.1,
              ease: "power2.out",
              onComplete: function () {
                // Reset height to auto after animation
                gsap.set(reviewsList, { height: "auto" });
              },
            });
          },
        });
      } else {
        // Fallback without GSAP - use CSS transition
        reviewItems.forEach((item, index) => {
          if (index >= startIndex && index < endIndex) {
            item.setAttribute("data-hidden", "false");
            item.style.display = "block";
          } else {
            item.setAttribute("data-hidden", "true");
            item.style.display = "none";
          }
        });
      }

      currentPage = page;

      // Update pagination numbers
      numberButtons.forEach((btn) => {
        const btnPage = parseInt(btn.getAttribute("data-page"), 10);
        if (btnPage === currentPage) {
          btn.classList.add("active");
        } else {
          btn.classList.remove("active");
        }
      });

      // Update arrow buttons with fade animation - hide/show at boundaries
      if (prevButton) {
        if (currentPage === 1) {
          prevButton.classList.add("disabled");
          if (typeof gsap !== "undefined") {
            gsap.to(prevButton, { opacity: 0, duration: 0.3 });
          }
        } else {
          prevButton.classList.remove("disabled");
          if (typeof gsap !== "undefined") {
            gsap.to(prevButton, { opacity: 1, duration: 0.3 });
          }
        }
      }

      if (nextButton) {
        if (currentPage === totalPages) {
          nextButton.classList.add("disabled");
          if (typeof gsap !== "undefined") {
            gsap.to(nextButton, { opacity: 0, duration: 0.3 });
          }
        } else {
          nextButton.classList.remove("disabled");
          if (typeof gsap !== "undefined") {
            gsap.to(nextButton, { opacity: 1, duration: 0.3 });
          }
        }
      }
    }

    // Number button clicks
    numberButtons.forEach((btn) => {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        const page = parseInt(this.getAttribute("data-page"), 10);
        if (!isNaN(page) && !btn.classList.contains("active")) {
          showPage(page);
        }
      });
    });

    // Previous button
    if (prevButton) {
      prevButton.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (currentPage > 1) {
          showPage(currentPage - 1);
        }
      });
    }

    // Next button
    if (nextButton) {
      nextButton.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (currentPage < totalPages) {
          showPage(currentPage + 1);
        }
      });
    }

    // Initialize first page
    showPage(1);
  }

  // Initialize all product review sections
  function initializeAll() {
    const sections = document.querySelectorAll(
      ".product-reviews[data-section-id]"
    );
    sections.forEach((section) => {
      const sectionId = section.getAttribute("data-section-id");
      if (sectionId && !section.hasAttribute("data-initialized")) {
        section.setAttribute("data-initialized", "true");
        initProductReviews(sectionId);
      }
    });
  }

  initializeAll();

  // Also initialize for dynamically loaded content in Shopify theme editor
  if (typeof window.Shopify !== "undefined" && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", initializeAll);
  }

  // Review Form Accordion and Interactions
  function initReviewForm(sectionId) {
    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (!section) return;

    const writeBtn = section.querySelector(".product-reviews-write-btn");
    const writeBtnText = writeBtn ? writeBtn.querySelector("span") : null;
    const formAccordion = section.querySelector("[data-review-form]");
    const form = section.querySelector("#ProductReviewForm");
    const cancelBtn = section.querySelector("[data-cancel-review]");
    const submitBtn = section.querySelector(".product-reviews-form-btn-submit");
    const starsContainer = section.querySelector("[data-rating-stars]");
    const starButtons = section.querySelectorAll(".product-reviews-form-star");
    const ratingInput = section.querySelector("#review-rating");
    const titleInput = section.querySelector("#ProductReviewForm-review_title");
    const charCount = section.querySelector("[data-char-count]");
    const contentTextarea = section.querySelector("#ProductReviewForm-body");
    const displayNameInput = section.querySelector("#ProductReviewForm-name");
    const emailInput = section.querySelector("#ProductReviewForm-email");

    if (!writeBtn || !formAccordion || !form) return;

    // Function to update button text
    function updateButtonText(isActive) {
      if (writeBtnText && writeBtn) {
        const writeText = writeBtn.getAttribute("data-text-write") || "Write a review";
        const cancelText = writeBtn.getAttribute("data-text-cancel") || "Cancel review";
        writeBtnText.textContent = isActive ? cancelText : writeText;
      }
    }

    // Toggle accordion
    writeBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const isActive = formAccordion.classList.contains("active");

      if (isActive) {
        // Close accordion
        const currentHeight = formAccordion.scrollHeight;
        formAccordion.style.height = currentHeight + "px";
        // Force reflow
        formAccordion.offsetHeight;
        formAccordion.style.height = "0px";
        formAccordion.classList.remove("active");
        updateButtonText(false);
      } else {
        // Open accordion
        formAccordion.classList.add("active");
        updateButtonText(true);
        // Get the natural height
        const targetHeight = formAccordion.scrollHeight;
        formAccordion.style.height = "0px";
        // Force reflow
        formAccordion.offsetHeight;
        // Animate to full height
        formAccordion.style.height = targetHeight + "px";

        // Scroll to top of form
        setTimeout(() => {
          formAccordion.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
          });
        }, 100);

        // Set to auto after transition completes
        const handleTransitionEnd = function () {
          if (formAccordion.classList.contains("active")) {
            formAccordion.style.height = "auto";
          }
          formAccordion.removeEventListener(
            "transitionend",
            handleTransitionEnd
          );
        };
        formAccordion.addEventListener("transitionend", handleTransitionEnd);
      }
    });

    // Star rating interactions
    if (starsContainer && starButtons.length > 0) {
      let selectedRating = 0;
      let hoverRating = 0;

      starButtons.forEach((star, index) => {
        const starValue = index + 1;

        // Mouse enter - fill stars up to this one
        star.addEventListener("mouseenter", function () {
          hoverRating = starValue;
          updateStarDisplay();
        });

        // Mouse leave - revert to selected rating
        star.addEventListener("mouseleave", function () {
          hoverRating = 0;
          updateStarDisplay();
        });

        // Click - save rating
        star.addEventListener("click", function (e) {
          e.preventDefault();
          selectedRating = starValue;
          hoverRating = 0;
          if (ratingInput) {
            ratingInput.value = selectedRating;
          }
          updateStarDisplay();
          // Remove active class from all, add to clicked and previous
          starButtons.forEach((s, i) => {
            if (i < selectedRating) {
              s.classList.add("active");
              s.classList.add("filled");
            } else {
              s.classList.remove("active");
              s.classList.remove("filled");
            }
          });
        });
      });

      function updateStarDisplay() {
        const ratingToShow = hoverRating || selectedRating;
        starButtons.forEach((star, index) => {
          const starValue = index + 1;
          if (starValue <= ratingToShow) {
            star.classList.add("filled");
          } else {
            star.classList.remove("filled");
          }
        });
      }
    }

    // Cancel button
    if (cancelBtn) {
      cancelBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Clear all inputs
        if (ratingInput) {
          ratingInput.value = "0";
        }
        if (titleInput) titleInput.value = "";
        if (contentTextarea) contentTextarea.value = "";
        if (displayNameInput) displayNameInput.value = "";
        if (emailInput) emailInput.value = "";

        // Reset stars
        starButtons.forEach((star) => {
          star.classList.remove("active", "filled");
        });

        // Close accordion
        const currentHeight = formAccordion.scrollHeight;
        formAccordion.style.height = currentHeight + "px";
        formAccordion.offsetHeight;
        formAccordion.style.height = "0px";
        formAccordion.classList.remove("active");
        updateButtonText(false);
      });
    }

    // Form validation and submission
    if (form && submitBtn) {
      function validateForm() {
        const rating = ratingInput ? parseInt(ratingInput.value, 10) : 0;
        const title = titleInput ? titleInput.value.trim() : "";
        const content = contentTextarea ? contentTextarea.value.trim() : "";
        const displayName = displayNameInput
          ? displayNameInput.value.trim()
          : "";
        const email = emailInput ? emailInput.value.trim() : "";

        const isValid =
          rating >= 1 &&
          rating <= 5 &&
          title.length > 0 &&
          content.length > 0 &&
          displayName.length > 0 &&
          email.length > 0 &&
          email.includes("@");

        submitBtn.disabled = !isValid;
        return isValid;
      }

      // Character counter for title
      if (titleInput && charCount) {
        titleInput.addEventListener("input", function () {
          const length = this.value.length;
          charCount.textContent = `${length}/100`;
          validateForm();
        });
      }

      // Real-time validation
      [ratingInput, contentTextarea, displayNameInput, emailInput].forEach(
        (input) => {
          if (input) {
            input.addEventListener("input", validateForm);
            input.addEventListener("change", validateForm);
          }
        }
      );

      // Initial validation
      validateForm();

      // Form submission - validate before allowing Shopify to submit
      if (form && submitBtn) {
        form.addEventListener("submit", function (e) {
          if (!validateForm()) {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }

          // Allow Shopify to handle the form submission
          // The form will reload with form.posted_successfully? = true if successful
        });
      }
    }
  }

  // Function to open accordion on page load if form was submitted
  function openAccordionOnFormSubmit() {
    const urlParams = new URLSearchParams(window.location.search);
    const contactPosted = urlParams.get("contact_posted") === "true";

    if (contactPosted) {
      // Find all product review sections
      const sections = document.querySelectorAll(
        ".product-reviews[data-section-id]"
      );

      sections.forEach((section) => {
        const formAccordion = section.querySelector("[data-review-form]");
        const successMessage = section.querySelector(
          ".product-reviews-form-success"
        );
        const writeBtn = section.querySelector(".product-reviews-write-btn");
        const writeBtnText = writeBtn ? writeBtn.querySelector("span") : null;

        if (formAccordion && (contactPosted || successMessage)) {
          // Open accordion automatically
          formAccordion.classList.add("active");

          // Update button text
          if (writeBtnText && writeBtn) {
            const cancelText = writeBtn.getAttribute("data-text-cancel") || "Cancel review";
            writeBtnText.textContent = cancelText;
          }

          // Get the natural height and set it
          const targetHeight = formAccordion.scrollHeight;
          formAccordion.style.height = targetHeight + "px";

          // Set to auto after a brief moment to allow for content rendering
          setTimeout(() => {
            formAccordion.style.height = "auto";

            // Scroll to success message if it exists
            if (successMessage) {
              successMessage.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest",
              });
            }
          }, 200);
        }
      });
    }
  }

  // Initialize review forms for all sections
  function initializeReviewForms() {
    const sections = document.querySelectorAll(
      ".product-reviews[data-section-id]"
    );
    sections.forEach((section) => {
      const sectionId = section.getAttribute("data-section-id");
      if (sectionId && !section.hasAttribute("data-review-form-initialized")) {
        section.setAttribute("data-review-form-initialized", "true");
        initReviewForm(sectionId);
      }
    });
  }

  // Initialize on DOM ready
  initializeReviewForms();

  // Check for form submission on page load and open accordion
  // Use a small delay to ensure DOM is fully rendered
  setTimeout(() => {
    openAccordionOnFormSubmit();
  }, 100);

  // Also initialize for dynamically loaded content
  if (typeof window.Shopify !== "undefined" && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function () {
      initializeReviewForms();
      openAccordionOnFormSubmit();
    });
  }
});
